// §4.4 partial — admin root routes.
// Covers: /admin (dashboard hub).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "./_layout/AdminLayout";

const AdminDashboardPage = lazyWithRetry(
  () => import("./pages/AdminDashboardPage"),
);
const MatrixSelfPage = lazyWithRetry(() => import("./pages/MatrixSelfPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin", Component: AdminDashboardPage },
      { path: "/admin/matrix-self", Component: MatrixSelfPage },
    ],
  },
];

export default routes;
